export default {
  title: "Carosello",
  subtitle: "Slide curate del carosello kiosk per regione.",
  empty: "Nessuna slide per questa regione.",
  emptyWritable: "Crea la prima slide del carosello per questa regione.",
  schedule: {
    always: "Sempre",
    from: "Dal",
    until: "Al",
  },
  columns: {
    slide: "Slide",
    audience: "Destinazione",
    schedule: "Programmazione",
    status: "Stato",
  },
  status: {
    visible: "Visibile ora",
    enabled: "Attiva",
    disabled: "Disattiva",
    scheduled: "Programmata",
    expired: "Terminata",
    draft: "Bozza",
  },
  statusHints: {
    draft:
      "Salvata come bozza — non è pubblicata, quindi non compare mai sui kiosk.",
    visible:
      "In diretta sui kiosk in questo momento (attiva e entro l’orario).",
    scheduled:
      "Ha un orario di inizio futuro. Comparirà sui kiosk quando arriverà quell’orario, se Attiva è accesa.",
    disabled:
      "Non compare sui kiosk — Attiva è spenta, oppure l’orario di fine è già passato.",
  },
  categories: {
    all: "Tutte le tab",
    select: "Seleziona tab",
  },
  structures: {
    all: "Tutte le strutture",
    count: "{{count}} strutture",
  },
  actions: {
    create: "Nuova slide",
    edit: "Modifica",
    delete: "Elimina",
    dragToReorder: "Trascina per riordinare",
  },
  form: {
    createTitle: "Nuova slide del carosello",
    createDescription: "Slide per i kiosk della regione {{region}}.",
    editTitle: "Modifica slide del carosello",
    sections: {
      content: "Testi",
      contentHint: "Titolo e descrizione localizzati della slide.",
      media: "Media",
      mediaHint:
        "Obbligatoria per pubblicare se non c’è un’attività collegata (in quel caso si usa la sua foto).",
      activity: "Attività collegata",
      activityHint: "Opzionale. Cerca un’attività per CTA e foto di fallback.",
      targeting: "Destinatari",
      targetingHint: "Su quali tab e strutture appare la slide.",
      visibility: "Visibilità",
      visibilityHint: "Attiva la slide e programma quando compare.",
    },
    titleLabel: "Titolo",
    descriptionLabel: "Descrizione (opzionale)",
    photoCropDescription:
      "Inquadra la foto per il banner del carosello home del kiosk (5:2).",
    activitySearch: "Cerca per nome, titolare o categoria…",
    activityNoResults: "Nessuna attività corrisponde alla ricerca.",
    activityListEmpty: "Nessuna attività in questa regione.",
    activityClear: "Rimuovi attività collegata",
    activityChange: "Cambia",
    activityInactive: "Non attiva",
    showButton: "Mostra pulsante per aprire l’attività",
    showButtonHint:
      "Aggiunge sulla slide un pulsante che apre i dettagli dell’attività collegata.",
    ignoreDistance: "Ignora distanza",
    ignoreDistanceHint:
      "Mantieni questa slide nel carosello anche se l’attività collegata è lontana dal kiosk.",
    categoriesLabel: "Tab home",
    categoriesHint:
      "Seleziona almeno una tab. Di default sono tutte selezionate così la slide appare ovunque. Collegando un’attività si preimposta la sua categoria.",
    showInAllStructures: "Mostra in tutte le strutture",
    showInAllStructuresHint:
      "Se disattivato, scegli in quali strutture mostrare la slide. Se attivo, la vedono tutte le strutture della regione.",
    structuresLabel: "Strutture",
    structuresHint: "Scegli in quali strutture può apparire questa slide.",
    enabled: "Attiva",
    enabledHint:
      "Se disattivata, la slide resta nascosta sui kiosk anche se è pubblicata e nel periodo programmato.",
    startsAt: "Inizio (opzionale)",
    endsAt: "Fine (opzionale)",
    clearSchedule: "Cancella",
    translate: "Genera traduzioni",
    incompleteTranslationsTitle: "Traduzioni incomplete",
    incompleteTranslationsBody:
      "Il titolo deve essere presente in tutte le lingue. La descrizione deve essere completa in tutte o vuota. Genera le parti mancanti dalla lingua già compilata, oppure completa a mano.",
  },
  delete: {
    title: "Eliminare la slide?",
    body: "“{{title}}” verrà rimossa definitivamente dal carosello.",
    confirm: "Elimina",
    success: "Slide eliminata",
  },
  toast: {
    created: "Slide creata",
    updated: "Slide salvata",
    draftSaved: "Bozza salvata",
    reordered: "Ordine aggiornato",
  },
  errors: {
    loadError: "Impossibile caricare le slide",
    titleRequired: "Il titolo è obbligatorio in tutte le lingue",
    titleRequiredDraft: "Aggiungi un titolo in almeno una lingua",
    descriptionPartial:
      "La descrizione deve essere completa in tutte le lingue oppure vuota",
    photoRequired:
      "Carica una foto oppure collega un’attività per usarne la foto.",
    categoriesRequired: "Seleziona almeno una tab home",
    structuresRequired:
      "Seleziona almeno una struttura, oppure mostralo in tutte",
    saveFailed: "Impossibile salvare la slide",
  },
} as const;
